import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { VisaInventoryService } from 'src/app/business-service/visa-inventory/visa-inventory.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { SendViaSocialMediaComponent } from '../../shared/popover/send-via-social-media/send-via-social-media.component';
import { LeadEmailInputComponent } from '../../shared/popover/lead-email-input/lead-email-input.component';
import { EmailService } from '../../shared/services/email/email.service';

@Component({
  selector: 'app-visa-important-information-view',
  templateUrl: './visa-important-information-view.component.html',
  styleUrls: ['./visa-important-information-view.component.scss'],
})
export class VisaImportantInformationViewComponent  implements OnInit {
  @ViewChild('sendthishtmldivtag', { static: false }) sendthishtmldivtag!: ElementRef;
  countryId:any;
  organizationId : any;
  visaInformation:any;

  constructor(
    private _modalController:ModalController,
    private _modalService:ModalsService,
    private _visaInventoryService: VisaInventoryService,
    private _popoverController: PopoverController,
    private _responseNotificationService: ResponseNotificationService,
    private _emailService: EmailService

  ) { }

  ngOnInit() {
    this.organizationId = localStorage.getItem("CId");
    if(this.countryId){
      this._visaInventoryService.getVisaInformationForCountryById(this.countryId).subscribe((res)=>{
        this.visaInformation = res;
      })
    }
  }

  closeModal(){
    this._modalController.dismiss();
  }

  openEditVisaInformation(){
    this.closeModal();
    this._modalService.openInventoryVisaInformationForm(this.countryId);
  }


   async sendvisachecklist(event: Event) {
       const popover = await this._popoverController.create({
         component: SendViaSocialMediaComponent,
         event: event,
         cssClass: "popup-component-social-media",
         componentProps: {
          hideWhatsappOption: true,
           onPathSelected: (data: any) => this.onSocialMediaActionOptionSelected(data), // Ensure the function is passed correctly
         }
       })
       return await popover.present()
     }
  
     onSocialMediaActionOptionSelected(data: any) {
      let selectedOption = data.path;
  
      switch (selectedOption) {
        case 'email': {
          this.sendVisaCheckListViaEmail();
          break;
        }
      }
    }
    applyinlineStyles(element: HTMLElement): string {
      const clonedElement = element?.cloneNode(true) as HTMLElement;
      const elements = clonedElement.querySelectorAll('*');
      
      elements.forEach(el => {
          const computedStyle = window.getComputedStyle(el);
          let styleString = '';
          
          for (let i = 0; i < computedStyle.length; i++) {
              const propertyName = computedStyle.item(i);
              const propertyValue = computedStyle.getPropertyValue(propertyName);
              styleString += `${propertyName}: ${propertyValue};`;
          }
          
          el.setAttribute('style', styleString);
      });
  
      return clonedElement.outerHTML;
  }

     async sendVisaCheckListViaEmail() {
        const htmlContent = this.sendthishtmldivtag.nativeElement.innerHTML;
        const popover = await this._popoverController.create({
          component: LeadEmailInputComponent,
          cssClass: 'large-popover',  
          componentProps: {
            countryId: this.countryId,
            onActionPerformed: (data:any) => {
              if(data){
                this._emailService.sendVisaCheckList(this.countryId, data,htmlContent).subscribe({
                  next: () => {
                    this._responseNotificationService.showMessage("Visa sent via email!");
                  },
                  error: (error) => {
                    console.error('Error sending Itinerary via email:', error);
                    this._responseNotificationService.showMessage("Failed to send Voucher via email!", true);
                  }
                })
              } 
            }
          }
        })
        return await popover.present()
      }
}
